import * as React from "react";
import { Helmet } from "react-helmet";
import { graphql } from "gatsby";
import { StaticQuery } from "gatsby";
export function SEO({ description = "", lang = "en", meta = [], keywords = [], title = "" }) {
    return (<StaticQuery query={graphql `
        query {
          site {
            siteMetadata {
              title
              description
              author
            }
          }
        }
      `} render={data => {
        const metaDescription = description || data.site.siteMetadata.description;
        return (<Helmet htmlAttributes={{ lang }} title={title} titleTemplate={`%s | ${data.site.siteMetadata.title}`} meta={[
            {
                name: "description",
                content: metaDescription
            },
            {
                property: "og:title",
                content: title
            },
            {
                property: "og:description",
                content: metaDescription
            },
            {
                property: "og:type",
                content: "website"
            },
            {
                name: "twitter:card",
                content: "summary"
            },
            {
                name: "twitter:creator",
                content: data.site.siteMetadata.author
            },
            {
                name: "twitter:title",
                content: title
            },
            {
                name: "twitter:description",
                content: metaDescription
            },
            {
                name: "keywords",
                content: distinct([]
                    .concat(data.site.siteMetadata.keywords || [])
                    .concat(keywords))
            },
            ...meta
        ]}/>);
    }}/>);
}
function distinct(arr) {
    return Array.from(new Set(arr));
}
//# sourceMappingURL=seo.jsx.map